import type { Location as RouterLocation } from "react-router-dom";

function getSessionStorage(): Storage | null {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    return null;
  }
}

export const setPreviousLocation = (loc: RouterLocation) => {
  const storage = getSessionStorage();
  if (storage) {
    storage.setItem("previousLocation", JSON.stringify(loc));
  }
};

export const getPreviousLocation = (): RouterLocation | null => {
  const storage = getSessionStorage();
  if (!storage) return null;
  const stored = storage.getItem("previousLocation");
  return stored ? JSON.parse(stored) : null;
};
